import React, { useEffect, useState, useMemo } from "react";
import Modal from "../../Components/Kanban/Modal/Modal";
import styled from "styled-components";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useSession } from "../../authentications/SessionContext";
import { useDispatch, useSelector } from "react-redux";
import { FaSearch } from "react-icons/fa";
import ReactSelect from "react-select";
import { subscriptionAction } from "../../Redux/Reducers/SubscriptionSlice";
import moment from "moment";
import {
  PAGINATION_DEFAULT_LIMIT,
  DISPLAY_DATE_FORMAT,
} from "../../utilities/constants";
import TableLoader from "../../Components/Loaders/TableLoader";
import SubscriptionView from "../../Components/SubscriptionComponents/SubscriptionView";
import { handleResponse } from "../../utilities/handleResponse";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { SUBSCRIPTION_LIST_TABLE_VIEW } from "../../utilities/tables-view-constants";
import TableHeader from "../../Components/Table/TableHeader";
import TableBody from "../../Components/Table/TableBody";
import Pagination from "../../Components/Table/TableFooter/Pagination";
import TableToolbar from "../../Components/Table/TableToolbar";
import { TableContainer } from "../../Components/StyledComponents/TableContainer/TableContainer";


const SubscriptionFilterList = [
  { label: "Show All", value: "" },
  { label: "Pending", value: JSON.stringify(["pending"]) },
  { label: "Free Trial", value: JSON.stringify(["free_trial"]) },
  { label: "Paid", value: JSON.stringify(["paid"]) },
];

const SubFirstSec = styled.div`
  justify-content: space-between;
  padding: 10px;

  .btn_and_icons {
    display: flex;
    justify-content: center;
  }
`;
const SubscriptionContainer = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 1.5rem;
  margin: 30px;
  border-radius: 20px;
`;
const Subscription = () => {
  const { sessionInfo } = useSession();
  const { company_id, context, is_suspended } = sessionInfo;
  
  const { subscriptionList, length, loading } = useSelector(
    (state) => state.subscription
  );
  const dispatch = useDispatch();
  const {
    ConfirmationModal,
    setTitle,
    setMetaData,
    toggleModal,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();

  const { language, translations } = useLanguage();
  const t = translations[language];
  const [searchQuery, setSearchQuery] = useState("");

  const [searchType] = useState("");
  const [selectedsubscription, setselectedsubscription] = useState(null);
  const [searchWithType, setSearchWithType] = useState("");

  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(PAGINATION_DEFAULT_LIMIT);

  const [SubscriptionTypeFilter, setSubscriptionTypeFilter] = useState(
    SubscriptionFilterList[0]
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setselectedsubscription(null);
  };

  const handleChangePage = (value) => {
    setCurrentPage(value);
  };
  const handleChangeSubscriptionFilter = (value, e) => {
    setSubscriptionTypeFilter(value);
  };
  const handleViewSubscription = (record) => {
    setselectedsubscription(record);
    setIsModalOpen(true);
  };

  const refetchData = () => {
    dispatch(
      subscriptionAction.fetchSubscriptionData({
        context,
        company_id,
        pagination: {
          offset: (currentPage - 1) * itemsPerPage,
          limit: itemsPerPage,
        },
        search: {
          query:  searchQuery,
          type: SubscriptionTypeFilter?.value || "",
        },
      })
    );
  };

  useEffect(() => {
    refetchData();
  }, [currentPage, searchQuery, searchType, SubscriptionTypeFilter]);
  useEffect(() => {
    if (typeof is_suspended && is_suspended === true) {
      setOpenConfirmationModal(true);
      setTitle("Subscription Suspended");
      setMetaData({
        dangerouslySetInnerHTML: ` <p class="">Unpaid Subscription Plan</p>`,
        secondaryButton: "Ok",
        buttonWrapperClassName: "justify-content-center",
      });
    }
  }, [is_suspended]);

  return (
    <div>
      <ConfirmationModal />
      <SubFirstSec className="d-flex  orders-first-section ">
        <div>
          <ReactSelect
            value={SubscriptionTypeFilter}
            options={SubscriptionFilterList}
            name="type"
            onChange={handleChangeSubscriptionFilter}
          />
        </div>
        <div className="btn_and_icons">
          <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
            <SubscriptionView
              selectedsubscription={selectedsubscription}
              handleCloseModal={() => {
                handleCloseModal();
                refetchData();
              }}
            />
          </Modal>
        </div>
      </SubFirstSec>
      <SubscriptionContainer>
        <TableContainer>
        <TableToolbar
            setSearchQuery={setSearchQuery}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
          <table className="table">
            <TableHeader tableHeaderList={SUBSCRIPTION_LIST_TABLE_VIEW} />
            <TableBody
              tableData={subscriptionList}
              handleRowClick={handleViewSubscription}
              tableBodyList={SUBSCRIPTION_LIST_TABLE_VIEW}
              isLoadingData={loading === "pending" || loading === "idle"}
              checkIsLoadingData
            />
          </table>

          <Pagination
            ListViewData={subscriptionList}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
            PAGINATION_DEFAULT_LIMIT={itemsPerPage}
            totalDataLength={length}
          />
        </TableContainer>
      </SubscriptionContainer>
    </div>
  );
};

export default Subscription;
